<template>
  <div class="ai-image-container">
    <!-- 顶部类型切换 -->
    <div class="type-tabs">
      <div 
        v-for="tab in typeTabs" 
        :key="tab.type"
        :class="['tab-item', { 'active': activeType === tab.type }]"
        @click="handleTypeChange(tab.type)"
      >
        {{ tab.name }}
      </div>
    </div>

    <!-- 工作流列表 -->
    <div class="workflow-list" v-loading="loading" @scroll="handleScroll" ref="workflowList">
      <div 
        v-for="workflow in workflowList" 
        :key="workflow.id"
        class="workflow-item"
        @click="handleWorkflowClick(workflow)"
      >
        <!-- 预览图背景 -->
        <div class="workflow-preview" :style="{ backgroundImage: workflow.preview ? `url(${workflow.preview})` : 'none' }">
          <!-- 无预览图时的占位 -->
          <div v-if="!workflow.preview" class="no-preview">
            <img src="./AiImage-Item.png" alt="默认预览图" />
          </div>
          
          <!-- 工作流信息叠加层 -->
          <div class="workflow-overlay">
            <!-- 默认显示的信息 -->
            <div class="workflow-info-default">
              <h3 class="workflow-title">{{ workflow.name }}</h3>
              <div class="workflow-price">
                <span class="price-label">消耗点数:</span>
                <span class="price-value">{{ workflow.price || 0 }}</span>
              </div>
            </div>
            
            <!-- 悬停时显示的详细信息 -->
            <div class="workflow-info-hover">
              <h3 class="workflow-title">{{ workflow.name }}</h3>
              <p class="workflow-description">{{ workflow.description || '暂无描述' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <div v-if="workflowList.length === 0 && !loading" class="empty-state">
      <i class="el-icon-picture-outline"></i>
      <p>暂无可用的AI工作流</p>
    </div>

    <!-- 滚动加载提示 -->
    <div v-if="loadingMore" class="loading-more">
      <i class="el-icon-loading"></i>
      <span>加载中...</span>
    </div>

  </div>
</template>

<script>
export default {
  name: 'AiImage',
  props: {
    token: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      loadingMore: false,
      generating: false,
      activeType: '',
      workflowList: [],
      hasMore: true,
      currentPage: 1,
      pageSize: 20,
      
      // 类型标签
      typeTabs: [
        { type: '', name: '全部' }
      ],

    }
  },
  mounted() {
    this.loadWorkflowTypes()
    this.loadWorkflows()
  },
  beforeDestroy() {
    // 清理滚动监听
    if (this.$refs.workflowList) {
      this.$refs.workflowList.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    // 加载工作流类型
    async loadWorkflowTypes() {
      try {
        const URL = `${process.env.HOST}/api/storage/storage/ai/workflow/types`
        const headers = {
          'Authorization': this.token
        }

        const response = await this.AJAX.get(URL, headers, {})
        
        if (response.code === 10000) {
          const types = response.datas.rows || []
          this.typeTabs = [
            { type: '', name: '全部' },
            ...types.map(type => ({ type: type.name, name: type.name }))
          ]
          debugger;
        }
      } catch (error) {
        console.error('加载工作流类型失败:', error)
      }
    },

    // 获取类型显示名称
    getTypeDisplayName(type) {
      const typeMap = {
        'scene': '场景',
        'material': '形象', 
        'prop': '道具',
        'upscale': '放大'
      }
      return typeMap[type] || type
    },

    // 加载工作流列表
    async loadWorkflows(isLoadMore = false) {
      if (!isLoadMore) {
        this.loading = true
        this.currentPage = 1
        this.workflowList = []
      } else {
        this.loadingMore = true
      }

      try {
        const URL = `${process.env.HOST}/api/storage/storage/ai/workflows`
        const headers = {
          'Authorization': this.token
        }

        const params = {
          page: this.currentPage,
          pageSize: this.pageSize,
          type: this.activeType || '',
          keyword: ''
        }

        const response = await this.AJAX.get(URL, headers, params)
        
        if (response.code === 10000) {
          const workflows = response.datas.rows || []
          const curPage = response.datas.page.currentPage || 1
          const totalPage = response.datas.page.totalPage || 1
          
          if (isLoadMore) {
            this.workflowList = [...this.workflowList, ...workflows]
          } else {
            this.workflowList = workflows
          }
          
          // 判断是否还有更多数据
          this.hasMore = curPage < totalPage
        } else {
          this.$message.error(response.message || '加载工作流失败')
        }
      } catch (error) {
        console.error('加载工作流失败:', error)
        this.$message.error('加载工作流失败')
      } finally {
        this.loading = false
        this.loadingMore = false
      }
    },

    // 类型切换
    handleTypeChange(type) {
      this.activeType = type
      this.loadWorkflows()
    },

    // 滚动处理
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      // 当滚动到底部附近100px时触发加载
      if (scrollTop + clientHeight >= scrollHeight - 100 && this.hasMore && !this.loadingMore) {
        this.loadMore()
      }
    },

    // 加载更多
    loadMore() {
      if (this.loadingMore || !this.hasMore) return
      this.currentPage++
      this.loadWorkflows(true)
    },

    // 点击工作流
    handleWorkflowClick(workflow) {
      // 跳转到SDUi页面并传入workflowId
      this.$emit('navigate-to-sdui', workflow.workflowId)
    },


    // 图片加载错误
    handleImageError(event) {
      event.target.style.display = 'none'
      event.target.nextElementSibling.style.display = 'flex'
    }
  }
}
</script>

<style scoped>
.ai-image-container {
  padding: 20px;
  background: #303030;
  min-height: 100vh;
}

/* 类型切换标签 */
.type-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  background: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.tab-item {
  padding: 8px 16px;
  border-radius: 20px;
  background: #f0f0f0;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.tab-item:hover {
  background: #e0e0e0;
}

.tab-item.active {
  background: #409eff;
  color: #fff;
}

/* 工作流列表 */
.workflow-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.workflow-item {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  height: 280px;
}

.workflow-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

/* 预览图背景 */
.workflow-preview {
  width: 100%;
  height: 100%;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.no-preview {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  color: #999;
  position: absolute;
  top: 0;
  left: 0;
}

.no-preview i {
  font-size: 48px;
  margin-bottom: 8px;
}

/* 工作流信息叠加层 */
.workflow-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.6) 100%);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 16px;
  transition: all 0.3s ease;
}

/* 默认状态信息 */
.workflow-info-default {
  display: block;
  transition: opacity 0.3s ease;
}

.workflow-item:hover .workflow-info-default {
  opacity: 0;
  pointer-events: none;
}

/* 悬停状态信息 */
.workflow-info-hover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 16px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.workflow-item:hover .workflow-info-hover {
  opacity: 1;
  pointer-events: auto;
}

.workflow-item:hover .workflow-overlay {
  background: linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.8) 100%);
}

/* 标题样式 */
.workflow-title {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  margin: 0;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
  word-wrap: break-word;
}

.workflow-info-default .workflow-title {
  font-size: 18px;
  margin-bottom: 8px;
}

.workflow-info-hover .workflow-title {
  font-size: 20px;
  margin-bottom: 12px;
}

/* 描述样式 */
.workflow-description {
  font-size: 14px;
  color: #fff;
  margin: 0 0 16px 0;
  line-height: 1.4;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 价格样式 */
.workflow-price {
  display: flex;
  align-items: center;
  gap: 6px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
}

.workflow-info-default .workflow-price {
  justify-content: flex-start;
}

.price-label {
  font-size: 14px;
  color: #fff;
  font-weight: normal;
}

.price-value {
  font-size: 18px;
  font-weight: bold;
  color: #ffd700;
}

.workflow-info-default .price-value {
  font-size: 16px;
}

/* 操作按钮 */
.workflow-actions {
  align-self: flex-end;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

.empty-state i {
  font-size: 64px;
  margin-bottom: 16px;
  display: block;
}

/* 滚动加载提示 */
.loading-more {
  text-align: center;
  padding: 20px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.loading-more i {
  animation: rotating 1s linear infinite;
}

@keyframes rotating {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 生成表单 */
.generate-form h4 {
  margin: 0 0 8px 0;
  color: #333;
}

.generate-form p {
  margin: 0 0 20px 0;
  color: #666;
  font-size: 14px;
}

.price-info {
  color: #e6a23c;
  font-weight: 600;
}

.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// AiImage.vue?79b2eae3